<template>
  <div v-if="ready" class="ClientWidget__Component">
    <div v-if="loading" class="loading-container">
      <ClipLoader color="#2e3f50" :loading="loading" :size="20" />
    </div>
    <div v-if="clientName && !loading">
      <div>{{ clientName }}</div>
      <div v-if="Email">מייל: {{ Email }}</div>
      <div>ח.פ: {{ idNumber }}</div>
      <div v-if="City">עיר: {{ City }}</div>
      <div v-if="Street">רחוב: {{ Street }}</div>
      <div v-if="HouseNumber">מספר בית: {{ HouseNumber }}</div>
      <div v-if="ZipCode">מיקוד: {{ ZipCode }}</div>
      <div v-if="typeof hasOpeningPage === 'boolean'">
        האם קיים דף ראשון בהסכם: {{ hasOpeningPage ? "כן" : "לא" }}
      </div>
      <div v-if="typeof HasGeneralContractForm === 'boolean'">
        האם קיימת הצהרה כללית: {{ HasGeneralContractForm ? "כן" : "לא" }}
      </div>
      <div v-if="typeof HasDriversLicense === 'boolean'">
        האם קיים רישיון נהיגה: {{ HasDriversLicense ? "כן" : "לא" }}
      </div>
      <div v-if="UpdateDate">תאריך עדכון: {{ displayDate() }}</div>
      <span v-if="fetch" class="loading">
        <ClipLoader color="#2e3f50" :loading="loading" :size="20" />
      </span>
    </div>
    <div v-if="ready && !clientName && !loading">אין לקוח משוייך</div>
    <a v-if="isAdmin && clientName && !isReadOnly" @click="openModal">
      <span class="preview">ערוך</span>
    </a>
    <a v-if="!isAdmin && clientName" :href="`/clients/${clientId}`">
      <span class="preview">הצג</span>
    </a>
  </div>
</template>

<script>
import { createNamespacedHelpers } from "vuex";
import { ClipLoader } from "@saeris/vue-spinners";
import moment from "moment";
import { ModalProgrammatic as Modal } from "buefy";
import DialogUpdateProfile from "../DialogUpdateProfile.vue";
import DialogUpdateClient from "../DialogUpdateClient.vue";
// import ProfileService from "../../services/ProfileService";
import LeasingCompaniesService from "../../services/LeasingCompaniesService";
import ReportService from "../../services/ReportService";

export default {
  name: "ClientWidget",
  props: ["ready", "namespace", "fetch", "delegate", "widget"],
  components: {
    ClipLoader,
  },
  data() {
    return {
      clientName: null,
      clientId: null,
      idNumber: null,
      data: null,
      loading: false,
      hasOpeningPage: null,
      HasGeneralContractForm: null,
      HasDriversLicense: null,
      UpdateDate: null,
      ZipCode: null,
      Street: null,
      HouseNumber: null,
      Email: null,
      City: null,
      isAdmin: null
    };
  },
  beforeCreate() {
    const { namespace } = this.$options.propsData;
    const { mapState } = createNamespacedHelpers(namespace);
    this.$options.computed = {
      ...mapState(["Profile"]),
      isReadOnly() {
        // true when NO fromProfileId (regular context - can't edit)
        // Can edit ONLY if: admin AND has fromProfileId (transfer context)
        // Otherwise read-only
        return !(this.isAdmin && this.widget?.fromProfileId);
      },
    };
  },
  created() {
    this.isAdmin = this.$store.state.auth?.user?.claims?.isAdmin === "True";
  },
  methods: {
    displayDate() {
      return moment(this.CreateDate).format("DD/MM/YYYY");
    },
    openModal() {
      // Use DialogUpdateClient for transfer context, DialogUpdateProfile for regular
      const dialogComponent = this.widget?.fromProfileId ? DialogUpdateClient : DialogUpdateProfile;
      const dialogProps = this.widget?.fromProfileId
        ? { clientId: this.clientId, leasingCompanyId: this.widget?.fromProfileId, delegate: this.delegate }
        : { profileId: this.clientId, delegate: this.delegate };

      Modal.open({
        component: dialogComponent,
        customClass: "entity-modal",
        props: dialogProps,
        events: {
          customEvent: (data) => {
            this.clientName = data.Name;
            this.idNumber = data.IdNumber;
            this.City = data.City?.Text || data.City || '';
            this.Street = data.Street?.Text || data.Street || '';
            this.HouseNumber = data.HouseNumber;
            this.ZipCode = data.ZipCode;
          }
        },
        canCancel: false,
        trapFocus: true,
      });
    },
    init() {
      // Use fromProfileId if provided (coming from transfers), otherwise use default Profile
      const fromProfileId = this.isAdmin && this.widget?.fromProfileId;
      const reportId = this.widget?.reportId;
      if (fromProfileId) {
        // Fetch client data by fromProfileId (transfer context)
        this.loading = true;
        ReportService.getTransferAdminById(reportId, fromProfileId).then((r) => {
          if (r.data) {
            this.clientName = r.data.Profile?.Name;
            this.clientId = r.data.Profile?.Id;
            this.idNumber = r.data.Profile?.IdNumber;
            this.Email = r.data.Profile?.Email;
            this.hasOpeningPage = r.data.Client?.HasOpeningPage;
            this.HasDriversLicense = r.data.Client?.HasDriversLicense;
            this.UpdateDate = r.data.Client?.UpdateDate;
            this.HasGeneralContractForm = r.data.Client?.HasGeneralContractForm;
            this.ZipCode = r.data.Client?.ZipCode || r.data.Profile?.ZipCode;
            this.Street = r.data.Client?.Street || r.data.Profile?.Street;
            this.HouseNumber = r.data.Client?.HouseNumber || r.data.Profile?.HouseNumber;
            this.City = r.data.Client?.City || r.data.Profile?.City;
          }
        }).catch(() => {
          // API call failed
        }).finally(() => {
          this.loading = false;
        });
      } else if (this.Profile) {
        this.clientName = this.Profile?.Name;
        this.clientId = this.Profile?.Id;
        this.idNumber = this.Profile?.IdNumber;
        this.Email = this.Profile?.Email;
        // Set address fields from Profile initially
        this.Street = this.Profile?.Street;
        this.HouseNumber = this.Profile?.HouseNumber;
        this.City = this.Profile?.City;
        this.ZipCode = this.Profile?.ZipCode;
        // Fetch additional data from Client (TransferForm) - may override address fields
        LeasingCompaniesService.getClient(this.clientId).then((r) => {
          if (r.data) {
            this.hasOpeningPage = r.data.Client?.HasOpeningPage;
            this.HasDriversLicense = r.data.Client?.HasDriversLicense;
            this.UpdateDate = r.data.Client?.UpdateDate;
            this.HasGeneralContractForm = r.data.Client?.HasGeneralContractForm;
            // Update address fields with Client (TransferForm) data, fallback to Profile
            this.ZipCode = r.data.Client?.ZipCode || r.data.Profile?.ZipCode || this.ZipCode;
            this.Street = r.data.Client?.Street || r.data.Profile?.Street || this.Street;
            this.HouseNumber = r.data.Client?.HouseNumber || r.data.Profile?.HouseNumber || this.HouseNumber;
            this.City = r.data.Client?.City || r.data.Profile?.City || this.City;
          }
        }).catch(() => {
          // API call failed, keep using Profile address fields already set above
        });
      }
      this.$emit("onReady", true);
    },
  },
  watch: {
    ready(newValue) {
      if (newValue) {
        this.init();
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.ClientWidget__Component {
  width: 100%;
  border-radius: 3px;
  padding: 10px;
  border: 1px solid #e4eaf1;
  background-color: #eef1f3;
  border-radius: 3px;
  position: relative;
}

.loading-container {
  display: flex;
  justify-content: center;
  padding: 10px;
}

.preview {
  position: absolute;
  left: 10px;
  top: 10px;
  color: #57b7ca;
  cursor: pointer;
  font-weight: 500 !important;

  &:hover {
    text-decoration: underline;
  }
}
</style>
